import React from 'react';
import VoiceSearch from './VoiceSearch';
import './App.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <VoiceSearch />
    </div>
  );
};

export default App;
